import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class DataService {
	baseUrl: string = environment.API_SERVER;
	constructor(private _http: HttpClient) {}

	getOptions(payload) {
		const params = new HttpParams()
			.set('sidx', 'optionId')
			.set('sord', 'desc')
			.set('rows', '3000')
			.set('page', '1')
			.set('_search', 'true')
			.set('filters', payload.filters);
		return this._http.get(this.baseUrl + '/public/options/', { params: params });
	}

	getPrb() {
		return this._http.get(this.baseUrl + '/public/prbs/');
	}
	getExport(payload) {
		return this._http.get(
			`${this
				.baseUrl}/collaborators/${payload.organizationId}/data/${payload.processType}/export/?query=${payload.query}`
		);
	}
	deleteValidationData(payload) {
		return this._http.delete(
			`${this
				.baseUrl}/collaborators/${payload.organizationId}/delete/validation-data/${payload.collaboratorContractorId}/`
		);
	}
	deleteBoardData(payload) {
		return this._http.delete(
			`${this
				.baseUrl}/collaborators/${payload.organizationId}/data/${payload.processType}/${payload.collaboratorContractorId}/`
		);
	}
	deleteVerificationData(payload) {
		return this._http.delete(
			`${this
				.baseUrl}/collaborators/${payload.organizationId}/delete/verification-data/${payload.collaboratorContractorId}/${payload.year}/`
		);
	}

	getDataStructure(payload) {
		return this._http.get(
			`${this.baseUrl}/public/collaborator/rule/${payload.organizationId}/${payload.processType}/`,
			{ params: payload.params }
		);
	}

	uploadBulkData(payload) {
		return this._http.post(
			`${this
				.baseUrl}/collaborators/${payload.organizationId}/data/${payload.processType}/year/${payload.year}/bulk/`,
			payload.body
		);
	}

	uploadSingleData(payload) {
		return this._http.post(
			`${this.baseUrl}/collaborators/${payload.organizationId}/data/${payload.processType}/year/${payload.year}/`,
			payload.body
		);
	}

	checkSingleData(payload) {
		return this._http.post(
			`${this
				.baseUrl}/collaborators/${payload.organizationId}/data/${payload.processType}/year/${payload.year}/check/`,
			payload.body
		);
	}

	// Financial Data Endpoints
	getVerificationData(payload) {
		return this._http.get(
			`${this.baseUrl}/collaborators/${payload.organizationId}/verification/data/?query=${payload.query}`,
			{ params: payload.params }
		);
	}
	getVerificationApprovalData(payload) {
		return this._http.get(`${this.baseUrl}/collaborators/${payload.organizationId}/batch_monitoring/`, {
			params: payload.params
		});
	}
	getVerificationMonitorData(payload) {
		return this._http.get(
			`${this.baseUrl}/collaborators/${payload.organizationId}/collaborator/verification/data/motinoring/`,
			{ params: payload.params }
		);
	}

	// Master Data Endpoints
	getValidationData(payload) {
		return this._http.get(
			`${this.baseUrl}/collaborators/${payload.organizationId}/validation/data/?query=${payload.query}`,
			{ params: payload.params }
		);
	}
	getDataMonitoring(payload) {
		return this._http.get(`${this.baseUrl}/collaborators/${payload.organizationId}/batch_monitoring/`, {
			params: payload.params
		});
	}
	getDataBatches(payload) {
		return this._http.get(`${this.baseUrl}/collaborators/${payload.organizationId}/collab_payment/`, {
			params: payload.params
		});
	}
	getDataBatch(payload) {
		return this._http.get(`${this.baseUrl}/collaborators/${payload.organizationId}/batches/${payload.batchId}/`, {
			params: payload.params
		});
	}
	approveDataBatch(payload) {
		return this._http.put(
			`${this
				.baseUrl}/collaborators/${payload.organizationId}/batch_monitoring/${payload.batchMonitoringId}/?status=${payload.status}`,
			payload.body
		);
	}

	// Master Data Endpoints
	getBoardData(payload) {
		return this._http.get(
			`${this.baseUrl}/collaborators/${payload.organizationId}/board_of_director/data/?query=${payload.query}`,
			{ params: payload.params }
		);
	}
	getBoardApprovalData(payload) {
		return this._http.get(`${this.baseUrl}/collaborators/${payload.organizationId}/batch_monitoring/`, {
			params: payload.params
		});
	}
	getBoardMonitorData(payload) {
		return this._http.get(
			`${this.baseUrl}/collaborators/${payload.organizationId}/board_of_director/data/motinoring/`,
			{ params: payload.params }
		);
	}

	getBatchesCount(payload) {
		return this._http.get(`${this.baseUrl}/collaborators/${payload.organizationId}/collab_payment/stats/`);
	}

	updateTransaction(payload) {
		return this._http.put(
			`${this.baseUrl}/collaborators/${payload.organizationId}/collab_payment/${payload.transactionId}/`,
			payload.body
		);
	}
}
